export const initialHousesState = {
  page: 1,
  size: 10,
  total: 0,
  meTotal: 0,
  house: {},
  housesList: [],
  meHousesList: [],
  mefilter: {},
  filtered: {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "changePage":
      return { ...state, page: action.payload };
    case "setSize":
      return { ...state, size: action.payload };
    case "setTotal":
      return { ...state, total: action.payload };
    case "setHouse":
      return { ...state, house: action.payload };
    case "setHouses":
      return { ...state, housesList: action.payload };
    case "setMeHousesList":
      return { ...state, meHousesList: action.payload };
    case "setMeFilter":
      return { ...state, mefilter: action.payload };
    case "setMeTotal":
      return { ...state, meTotal: action.payload };
    case "setFilterd":
      return { ...state, filtered: action.payload };
    default:
      return state;
  }
};
